import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import Card from 'react-bootstrap/Card';

import DaySetting from './DaySetting/DaySetting';
import Button from 'react-bootstrap/Button';

import classes from './Setting.css';
import Alert from 'react-s-alert';
import { getCurrentTimezone } from '../../../../store/utility';

import { TextButton } from '../../../../components/UI/TextLink/TextLink';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

class Setting extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            timezone: getCurrentTimezone(),
            monday: this.props.weekSchedule.days.monday, 
            tuesday: this.props.weekSchedule.days.tuesday,
            wenesday: this.props.weekSchedule.days.wenesday,
            thursday: this.props.weekSchedule.days.thursday,
            friday: this.props.weekSchedule.days.friday,
            saturday: this.props.weekSchedule.days.saturday,
            sunday: this.props.weekSchedule.days.sunday,
        }
    }

    componentDidMount() {
    }

    setDaySchedule = (day, checked, timeFrom, timeTo) => {
        if (checked===true){
            this.setState({[day]: {from: timeFrom, to: timeTo}});
        }
        else{
            this.setState({[day]: null});
        }
    }

    saveSetting = () => {
        Alert.info('setting is saved');
        this.props.saveScheduleSetting(this.calendarId, this.state);
        this.callBack();
    }

    callBack = () => {
        if (this.props.callBack) {
            this.props.callBack();
        }
    }

    render(){
        let displaySize = ( (this.props.isMobile) ? 'none' : 'none' );
        return (
            <Container>
            <Card bsPrefix={classes.CardBody}>
            <Card.Header>
                <b>Changing Schedule</b> <FontAwesomeIcon icon={faQuestionCircle} onClick={this.props.questionCallback} / >
            </Card.Header>
            <Card.Body>

            <Row>
                <Col>
                    Current Timezone: <b>{this.state.timezone}</b>
                </Col>
            </Row>

            <Row>
                <Col>
                <TextButton text=" How it works? " callback={this.props.questionCallback} > 
                <FontAwesomeIcon icon={faQuestionCircle} />
                </TextButton>
                </Col>
            </Row>

            <div className={classes.DaySettingWindow}>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'monday'} displayDay='Monday' currentTimeSlot={this.props.weekSchedule.days.monday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'tuesday'} displayDay='Tuesday' currentTimeSlot={this.props.weekSchedule.days.tuesday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'wenesday'} displayDay='Wenesday' currentTimeSlot={this.props.weekSchedule.days.wenesday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'thursday'} displayDay='Thursday' currentTimeSlot={this.props.weekSchedule.days.thursday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'friday'} displayDay='Friday' currentTimeSlot={this.props.weekSchedule.days.friday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'saturday'} displayDay='Saturday' currentTimeSlot={this.props.weekSchedule.days.saturday}></DaySetting>
                <DaySetting setDayScheduleFunc={this.setDaySchedule} day={'sunday'} displayDay='Sunday' currentTimeSlot={this.props.weekSchedule.days.sunday}></DaySetting>
            </div>
            
            <Row>
                <Col md={6} sm={12}>
                    <div className={classes.ButtonLayout}>
                        <Button size={displaySize} variant="info" onClick={this.saveSetting} block> Save </Button>
                    </div>
                </Col>
                <Col md={6} sm={12}>
                    <div className={classes.ButtonLayout}>
                        <Button size={displaySize} variant="outline-info" onClick={this.callBack} block> Cancel </Button>
                    </div>
                </Col>
            </Row>
            
            </Card.Body>
            </Card>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        calendarId: state.auth.calendarId,
        weekSchedule: state.setting.weekSchedule,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveScheduleSetting: (calendar_id, scheduleSetting) => dispatch( actions.scheduleSettingSet(calendar_id, scheduleSetting) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Setting);


// WEBPACK FOOTER //
// ./src/containers/Profile/Setting/ScheduleChange/Setting.js